import * as React from 'react';
import { FormField } from '@ixicare/ui';
import { FieldValue } from '../schema';
import styles from '../styles.module.css';

const SAMPLE = `{
  "type": "Feature",
  "geometry": {
    "type": "Polygon",
    "coordinates": [
      [
        [3.327355, 51.048122],
        [3.328101, 51.048654],
        [3.329810, 51.047932]
      ]
    ]
  }
}`;

interface Props {
  value: FieldValue;
  label: React.ReactNode;
}

const PolygonControl: React.FC<Props> = ({ value, label }) => {
  let body = SAMPLE;
  if (value && typeof value === 'string') {
    body = value;
  } else if (value && typeof value === 'object') {
    try {
      body = JSON.stringify(value, null, 2);
    } catch {
      body = SAMPLE;
    }
  }
  return (
    <FormField label={label}>
      <pre className={styles.code}>{body}</pre>
    </FormField>
  );
};

export default PolygonControl;
